import React, { useState } from 'react';
import { Form } from 'antd';
import styles from './styles';
import { useHistory } from 'react-router-dom';
import { Fonts } from '../../../shared/theme/';
import CommonStyle from '../../../shared/theme/common-style';
import { Images } from '../../../shared/theme';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../shared/components/rbh-text/styles';
import { useDispatch } from 'react-redux';
import { CommonValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { RBHBox, RBHButton, RBHImage, RBHText, RBHTextInput } from '../../../shared/components/';
import { authSagas } from '../../auth-saga';
import { AUTH_REQUEST_ID_LIST } from '../../auth-constant';
import { AuthService } from '../../auth-services';
import { AuthHelper } from '../../auth-helper';
import images from '../../../shared/theme/images';
import { CheckCircleOutlined } from '@ant-design/icons/lib';

export const ForgotScreen: React.FC<Props> = () => {
  const [form] = Form.useForm();
  const [formInvalid, setFormInvalid] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isResendSuccess, setIsResendSuccess] = useState(false);

  // const goResetPassword = () => {
  //   history.push('/setnewpassword');
  // };

  const goLogin = () => {
    history.push('/signin');
  };

  const checkFormatEmail = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const checkFormEmailInvalid = () => {
    let invalid = false;
    // Check that every field has value
    const values = form.getFieldsValue();
    for (const key in values) {
      if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }

    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }

    setFormInvalid(invalid);
  };

  const onFinishEmail = (values: any) => {
    const data = {
      email: values.txtEmail
    };
    dispatch(httpCreators.request({
      service: AuthService.forgotPassword,
      serviceParams: data,
      id: AUTH_REQUEST_ID_LIST.FORGOT_PASSWORD,
      sagaHandler: authSagas.forgotPasswordHandle,
      callbackParams: goLogin,
    }));
  };

  return (
    <RBHBox style={styles.forgot_layout}>
      <RBHBox style={styles.forgot_content}>
        {isResendSuccess ?
          <RBHBox style={styles.successBox}>
            <RBHBox style={styles.contentModal}>
              <RBHBox style={styles.successIconBox}>
                <CheckCircleOutlined id={'icon_success'} translate={null} style={styles.successIconImage} />
              </RBHBox>
              <RBHBox style={CommonStyle.paddingTopLarge}>
                <RBHText id={'success_title'} style={Fonts.style.textHeaderKanitMediumFakeBlack}>
                  <FormattedMessage id={'main.forgotpassword.successbox.title'} />
                </RBHText>
              </RBHBox>
              <RBHBox style={CommonStyle.paddingTop}>
                <RBHText id={'success_description'} style={Fonts.style.textDescription}>
                  <FormattedMessage id={'main.forgotpassword.successbox.description'} />
                </RBHText>
              </RBHBox>
              <RBHBox style={CommonStyle.paddingTopLarge}>
                <RBHButton id={'success_button'} style={styles.buttonBox} onClick={goLogin}>
                  <FormattedMessage id={'main.setnewpassword.successbox.button'} />
                </RBHButton>
              </RBHBox>
            </RBHBox>
          </RBHBox> :
          <RBHBox style={styles.forgotBox}>
            <RBHBox style={{ padding: 40 }}>
              <RBHBox style={styles.iconBox}>
                <RBHImage style={styles.iconImage} src={Images.logoIcon} />
              </RBHBox>
              <RBHBox style={CommonStyle.paddingTopLarge}>
                <RBHText id={'forgotpassword_title'} style={Fonts.style.headerFakeBlack}>
                  <RBHImage data-testid={'back_icon'} id={'back_icon'} style={styles.iconBack} src={images.back}
                    onClick={goLogin} />
                  <FormattedMessage id={'main.forgotpassword.title'} />
                </RBHText>
                <RBHText id={'forgotpassword_description'}
                  style={Fonts.style.textcontentKanitRegular}>
                  <FormattedMessage id={'main.forgotpassword.description'} />
                </RBHText>
              </RBHBox>
              <RBHBox style={CommonStyle.paddingTopLarge}>
                <Form size='small' form={form} style={styleText.formText}
                  onFieldsChange={checkFormEmailInvalid} onFinish={onFinishEmail}>
                  <Form.Item colon={false} name='txtEmail' label={<FormattedMessage id={'main.forgotpassword.form.title'} />}
                    rules={[
                      {
                        pattern: CommonValidator.Email.regexPattern,
                        message: <FormattedMessage id={'main.login.email.format.valid'} />
                      }
                    ]}
                    validateTrigger={['onChange', 'onBlur']}>
                    <RBHTextInput id='txtEmail' placeholder={'main.forgotpassword.form.placeholder'}
                      autoComplete='off' onBlur={() => checkFormatEmail('txtEmail')} />
                  </Form.Item>
                  <RBHButton id={'forgotpassword_button'} style={styles.buttonBox}
                    disabled={formInvalid} type='primary' htmlType='submit'>
                    <FormattedMessage id={'main.forgotpassword.form.button'} />
                  </RBHButton>
                </Form>
              </RBHBox>
            </RBHBox>
          </RBHBox>
        }
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
